import { APP_NAMES } from '../types/app';
import { getAppName } from '../utils/common';

// There can naming difference for the same feature between ESP and RRA. Consolidate and add them here

const appName = getAppName();

export const Industry_Verticals: string = appName === APP_NAMES.RRA ? 'Verticals' : 'Industries';

const TarBuilder = {
  appName: 'TAR Builder',
  appDescription: 'Build and manage Target company lists for your projects and workflows.',
  allCreatedLists: {
    header: 'My Target Company Lists',
    table: {
      column: {
        listName: 'TAR Name',
      }
    }
  },
  modal: {
    copyToOtherApps: {
      description: 'Create a company list from saved companies in the TAR list.\nThe original list won’t be changed.',
      dynamicListLabel: 'Dynamic list',
      dynamicListCheckedText: 'All changes to this Company Builder project will automatically reflect on the company list.',
      dynamicListUncheckedText: 'Changes to this Company Builder project will not reflect on the company list.',
    }
  },
  button: {
    createNewList: {
      primaryText: 'Create TAR',
    },
  }
};

const CompanyResearch = {
  appName: 'Company Research',
  appDescription: 'Build and manage Company Research lists for your projects and workflows.',
  allCreatedLists: {
    header: 'My Company Research Lists',
    table: {
      column: {
        listName: 'Name',
      }
    }
  },
  modal: {
    copyToOtherApps: {
      description: 'Create a company list from saved companies in the research list.\nThe original list won’t be changed.',
      dynamicListLabel: 'Dynamic list',
      dynamicListCheckedText: 'All changes to this Company Builder project will automatically reflect on the company list.',
      dynamicListUncheckedText: 'Changes to this Company Builder project will not reflect on the company list.',
    }
  },
  button: {
    createNewList: {
      primaryText: 'Create',
    },
  }
};

const PeopleFinder = {
  appName: 'People Finder',
  appDescription: "Search by attributes across RRA's 2 million updated and enriched candidates.",
  appIcon: 'person_search',
};

const Projects = {
  appName: 'Projects',
  appDescription: 'Create and manage projects for executive scouting and market insights in one suite.',
  appIcon: 'search',
};

export const CompanyBuilder = appName === APP_NAMES.RRA ? TarBuilder : CompanyResearch;
export const PeopleSearch = appName === APP_NAMES.RRA ? PeopleFinder : Projects;
